"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AlertsProgress = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const reactstrap_1 = require("reactstrap");
class AlertsProgress extends react_1.default.Component {
    constructor(props) {
        super(props);
        this.state = {
            count: 100,
        };
        this.timer = this.timer.bind(this);
    }
    componentDidMount() {
        const intervalId = setInterval(this.timer, 80);
        // store intervalId in the state so it can be accessed later:
        this.setState({
            intervalId,
        });
    }
    componentWillUnmount() {
        // use intervalId from the state to clear the interval
        clearInterval(this.state.intervalId);
    }
    timer() {
        const newCount = this.state.count - 1;
        if (newCount >= 0) {
            this.setState({
                count: newCount,
            });
        }
        else {
            clearInterval(this.state.intervalId);
            const callBack = () => {
                if (this.props.done) {
                    this.props.done();
                }
            };
            setTimeout(callBack, 100);
        }
    }
    render() {
        return ((0, jsx_runtime_1.jsx)(reactstrap_1.Progress, { animated: true, color: this.props.type, value: (this.state.count - 100) * -1 }, void 0));
    }
}
exports.AlertsProgress = AlertsProgress;
